import Api from "../../Services/index";
import router from "../../router";


export const login = {
  namespaced: true,
  state: {
    codNrbeEn: "",
    email: "",
    token: null,
  },
  getters: {
    IS_AUTHENTICATED(state) {
      return state.token == null ? false : true;
    },
  },
  mutations: {
    changeSupplierId(state, payload) {
      state.supplierId = payload
    },

    token(state, payload) {
      state.token = payload;
    },

    codNrbeEn(state, payload) {
      state.codNrbeEn = payload;
    },

    SET_TOKEN(state, payload) {
      state.token = payload;
    },
  },
  actions: {
    set_codNrbeEn({ commit }) {
      try {
        let tenCod = localStorage.getItem("codNrbeEn");
        const codEntidad = router.app.$route.query.codNrbeEn;
        if (router.app.$route.query.codNrbeEn != tenCod) {
          commit('codNrbeEn', codEntidad)
          localStorage.setItem("codNrbeEn", codEntidad)
        }
        return codEntidad
      } catch (error) {
        this.$showError(this, error.response.data);
        return Promise.reject(error);
      }
    },

    async forgot_new_password({ commit }, payload) { //Cambiar Contraseña        
      try {
        let { data } = await Api.patch('/usuarios/credenciales', payload)
        commit('SET_TOKEN', data.token)
        return data
      } catch (error) {
        this.$showError(this, error.response.data);
        return Promise.reject(error)
      }
    },
  },
}